<template>
  <div v-if="list && list.length">
    <div class="product" v-for="(item, index) of list">
      <div class="flex-ac productitem">
        <img class="img" v-lazy="item.img_path" alt="" />
        <div class="ml7 flex-1" style="min-height: 0.8rem">
          <p class="f13 name ell-over-1">{{ item.name }}</p>
          <p class="f11 spec color-6C flex-js-ac">
            <span>{{ item.spec }}</span>
            <span>X{{ item.num }}</span>
          </p>
        </div>
      </div>
      <div class="giftproduct">
        <p class="f14">
          <b>选择赠品：</b>
          (可选择{{ item.buygiftnum }}个)您已选择
          <span class="color-FC0324">{{ item.choosegiftnum }}</span>
          个赠品
        </p>
        <div class="flex-ac giftproductitem" v-for="giftitem of item.buygiftlist" :id="giftitem.itemid">
          <img class="img" v-lazy="giftitem.img_path" alt="" />
          <div class="ml7 flex-1" style="min-height: 0.6rem" :num="giftitem.num">
            <p class="f13 name ell-over-1">{{ giftitem.name }}</p>
            <p class="f11 spec color-6C flex-js-ac">{{ giftitem.spec }}</p>
            <van-stepper :long-press="false" integer class="goods_stepper" :min="0" :disable-plus="item.buygiftnum <= item.choosegiftnum || item.buygiftlist.length == 1" :disable-minus="item.buygiftlist.length == 1" disable-input v-model="giftitem.num" @change="changeHandle(index)" />
          </div>
        </div>
      </div>
    </div>
    <div style="height: 0.84rem"></div>
    <footer class="flex-ac footerIOS">
      <div style="padding: 0.05rem 0">
        <div class="sureBtn" :class="{ graySureBtn: disabledSubmit }" @click="submit">确定</div>
      </div>
    </footer>
  </div>
</template>

<script>
import { fenxiang, unencryption } from '../../assets/common/js/config'

export default {
  name: 'freeGiftZone_buyGift',
  data() {
    return {
      disabledSubmit: true,
      list: []
    }
  },
  mounted() {
    fenxiang({ path: 'freegiftzone_buygift' })
    this.getData()
  },
  methods: {
    getData() {
      this.list = []
      if (localStorage.getItem('shopConfirmResult')) {
        var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
        this.list = shopConfirmResult.buygiftrule && shopConfirmResult.buygiftrule.ruleList ? shopConfirmResult.buygiftrule.ruleList : []
        this.list.map((item) => {
          if (!item.choosegiftnum) item.choosegiftnum = 0
          item.buygiftlist.map((giftitem) => {
            if (!giftitem.num) giftitem.num = 0
          })
        })
        console.log(this.list)
        this.$forceUpdate()
        this.$nextTick(() => {
          if (this.$route.query.itemid) {
            let giftOffsetTop = document.getElementById(this.$route.query.itemid).offsetTop
            document.body.scrollTop = giftOffsetTop
          }
          this.graySubmitBtn()
        })
      }
    },
    changeHandle(index) {
      console.log(this.list[index])
      this.list[index].choosegiftnum = 0
      this.list[index].buygiftlist.map((giftitem) => {
        this.list[index].choosegiftnum += giftitem.num
      })
      this.graySubmitBtn()
      this.$forceUpdate()
    },
    graySubmitBtn() {
      let temp = 0
      this.list.map((item) => {
        if (item.choosegiftnum && item.choosegiftnum != item.buygiftnum) {
          temp = 1
        }
      })
      this.disabledSubmit = temp == 1 ? true : false
    },
    submit() {
      if (this.disabledSubmit) {
        return
      }
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.buygiftrule.ruleList = this.list
      shopConfirmResult.buygiftlist = [] // 买赠活动说选赠品集合
      shopConfirmResult.buygiftlist_submit = [] // 买赠所需赠品集合（提交下单数据）
      this.list.map((item) => {
        item.buygiftlist.map((giftitem) => {
          if (giftitem.num > 0) {
            // isbuygift|isgolist 前端自建参数
            giftitem.isbuygift = 1
            if (item.buygiftlist.length > 1) giftitem.isgolist = 1
            shopConfirmResult.buygiftlist.push(giftitem)
            shopConfirmResult.buygiftlist_submit.push({
              itemid: giftitem.itemid,
              num: giftitem.num
            })
          }
        })
      })
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      this.$router.replace({
        path: unencryption(this.$route.query.path)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.product {
  padding: 0.15rem 0.1rem;
  margin: 0.1rem;
  border-radius: 0.08rem;
  background: #ffffff;
}
.giftproduct {
  background: #f4f6f7;
  padding: 0.1rem;
  border-radius: 0.04rem;
  margin-top: 0.1rem;
  > p {
    color: #333333;
  }
  .giftproductitem {
    margin-top: 0.1rem;
    .img {
      width: 0.6rem;
      height: 0.6rem;
    }
  }
}
.img {
  width: 0.8rem;
  height: 0.8rem;
}
.ml7 {
  margin-left: 0.07rem;
}
.name {
  color: #292929;
}
.spec {
  color: #6c6c6c;
  margin-top: 0.05rem;
}
.goods_stepper {
  float: right;
}
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  border-top: 2px solid #dfdfdf;
  background: white;
  width: 100%;
  min-height: 0.48rem;
  justify-content: flex-end;
  .sureBtn {
    width: 1.12rem;
    height: 0.38rem;
    background: linear-gradient(90deg, #fc0324 0%, #ff144f 100%);
    font-size: 0.16rem;
    text-align: center;
    line-height: 0.38rem;
    border-radius: 0.19rem;
    margin-right: 0.1rem;
    color: white;
    &.graySureBtn {
      opacity: 0.7;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopcart/freeGiftZone_buyGift.vue